import {
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import HeaderAndSidebar from 'components/templates/HeaderAndSidebar';
import { unixTimeToString } from 'libs';
import {
  Income,
  Outgo,
  MonthlyTotalAsset,
  convertToOutgoKindDisplayString,
  convertToIncomeKindDisplayString,
} from 'types';

type Props = {
  incomes: Income[];
  outgos: Outgo[];
  monthlyTotalAssets: MonthlyTotalAsset[];
  isLoadingIncomes: boolean;
  isLoadingOutgos: boolean;
  isLoadingTotalAssets: boolean;
};

const Dashboard: React.FC<Props> = ({
  incomes,
  outgos,
  monthlyTotalAssets,
  isLoadingIncomes,
  isLoadingOutgos,
  isLoadingTotalAssets,
}) => (
  <HeaderAndSidebar pageTitle="Dashboard">
    <Grid item xs={12} md={12} lg={12}>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          支出
        </Typography>
        {isLoadingIncomes ? (
          <CircularProgress />
        ) : (
          <Table stickyHeader sx={{ maxHeight: 440 }}>
            <TableHead>
              <TableRow>
                <TableCell>登録日</TableCell>
                <TableCell>名前</TableCell>
                <TableCell>種別</TableCell>
                <TableCell>金額</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {outgos.map((outgo) => (
                <TableRow key={outgo.id}>
                  <TableCell>{unixTimeToString(outgo.registered_at)}</TableCell>
                  <TableCell>{outgo.name}</TableCell>
                  <TableCell>
                    {convertToOutgoKindDisplayString(outgo.kind)}
                  </TableCell>
                  <TableCell>{outgo.amount.toLocaleString('ja-JP')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Grid>
    <Grid item xs={12} md={12} lg={12}>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
        <Typography component="h2" variant="h6" color="primary">
          収入
        </Typography>
        {isLoadingOutgos ? (
          <CircularProgress />
        ) : (
          <Table stickyHeader sx={{ maxHeight: 440 }}>
            <TableHead>
              <TableRow>
                <TableCell>登録日</TableCell>
                <TableCell>名前</TableCell>
                <TableCell>種別</TableCell>
                <TableCell>金額</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {incomes.map((income) => (
                <TableRow key={income.id}>
                  <TableCell>
                    {unixTimeToString(income.registered_at)}
                  </TableCell>
                  <TableCell>{income.name}</TableCell>
                  <TableCell>
                    {convertToIncomeKindDisplayString(income.kind)}
                  </TableCell>
                  <TableCell>{income.amount.toLocaleString('ja-JP')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Grid>
    <Grid item xs={12}>
      <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
        <Typography component="h2" variant="h6" color="primary">
          総資産
        </Typography>
        {isLoadingTotalAssets ? (
          <CircularProgress />
        ) : (
          <Table stickyHeader sx={{ maxHeight: 440 }}>
            <TableHead>
              <TableRow>
                <TableCell>登録日</TableCell>
                <TableCell>金額</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {monthlyTotalAssets.map((asset) => (
                <TableRow key={asset.id}>
                  <TableCell>{`${asset.year}/${asset.month}`}</TableCell>
                  <TableCell>
                    {(asset.wallet + asset.bank).toLocaleString('ja-JP')}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Grid>
  </HeaderAndSidebar>
);

export default Dashboard;
